import { array, mixed, number, object, string } from '@calendly/form/validation'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { templateLength } from '@calendly/rich-text-editor'

import { MAX_SMS_BODY_LENGTH } from 'services/workflows/actions'

import { delocalizeContent, getTimingType, localizeTemplateVariables, showSubject } from './config'
import { isSmsNotification } from './sms_body_field'


const getTemplateErrorMessage = (response) => {
  const template = response.templates[0]
  const error = template.errors[0]

  if (!error) {
    return null
  }

  switch (error.type) {
    case 'invalid_variable':
      return `${I18n.t('publisher.components.editor.variable_invalid')}: {{${error.content}}}`
    case 'not_closed':
      return `${I18n.t('publisher.components.editor.variable_not_closed')}: {{`
    case 'not_opened':
      return `${I18n.t('publisher.components.editor.variable_not_opened')}: }}`
    case 'invalid_syntax':
      return I18n.t('publisher.components.editor.invalid_syntax')
    default:
      return error.type.replaceAll('_', ' ')
  }
}

const getTemplateValidator = (notification, fieldName) => async (obj, context) => {
  if (obj.source !== 'user') {
    return true
  }

  const value = obj.html

  const [success, response] = await httpRequest({
    url: '/api/publishers/templates/validate',
    method: 'POST',
    data: {
      templates: {
        0: {
          identifier: fieldName,
          content: delocalizeContent(value, localizeTemplateVariables(notification.variables[fieldName])),
          variables: notification.variables[fieldName].map(({ name }) => name)
        }
      }
    }
  })

  if (!success) {
    return context.createError({
      message: response.message
    })
  }

  const errorMessage = getTemplateErrorMessage(response)

  if (!errorMessage) {
    return true
  }

  return context.createError({
    message: errorMessage
  })
}

const getMinIntervals = (notification) => (getTimingType(notification.kind) === 'post' ? 0 : 1)

const smsBodyNotificationSchema = (notification) => mixed().test(
  'body', '', getTemplateValidator(notification, 'body')
).test(
  'validateSmsLength', '', (obj, { createError }) => {
    if (obj.source !== 'user') {
      return true
    }
    if (templateLength(obj) > MAX_SMS_BODY_LENGTH) {
      return createError({
        message: I18n.t('publisher.event_types.notifications.invitee_sms_reminder.counter_validation_error')
      })
    }
    return true
  })

export const buildNameNotificationSchema = (notification) => object({
  timings: array(object({
    interval: number()
      .typeError(I18n.t('errors.messages.not_a_number'))
      .required()
      .min(getMinIntervals(notification), I18n.t('errors.messages.greater_than_or_equal_to', { count: getMinIntervals(notification) }))
  })),
  subject: showSubject(notification.kind) ? mixed().test(
    'body', '', getTemplateValidator(notification, 'subject')
  ) : null,
  body: isSmsNotification(notification.kind)
    ? smsBodyNotificationSchema(notification) : mixed().test(
      'body', '', getTemplateValidator(notification, 'body')
    )
})

export const getCancellationPolicyValidation = () => object({
  cancellationPolicy: string().max(1024)
})
